module.exports = __webpack_public_path__ + "1dae8ebc7a86fd7a5e56b386dd35540b.svg";